export default __webpack_public_path__ + "static/media/logo-sobre-fondo-azul-oscuro.91ddf679.svg";